// Composant Footer - Affiche les liens de navigation et le copyright

import React, { Component } from "react";
import { NavLink } from "react-router-dom";

export default class Footer extends Component {
  render() {
    return (
      <footer class="bg-white shadow dark:bg-gray-900 ">
        <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
          <div class="sm:flex sm:items-center sm:justify-between">
            <ul class="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
              <li class="mr-4 hover:underline md:mr-6">
                <NavLink to="/about">À propos</NavLink>
              </li>
              <li class="hover:underline">
                <NavLink to="/contact">Contact</NavLink>
              </li>
            </ul>
          </div>
          <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
          <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">
            © {new Date().getFullYear()}{" "}
            <a href="/" class="hover:underline">
              SmoFR
            </a>
          </span>
        </div>
      </footer>
    );
  }
}
